export const bonuses = [
  {
    number: 1,
    title: "The 15-Minute Case Command Protocol™",
    value: "$37",
    image: "https://cdn.magicpatterns.com/uploads/j1uLJSKLbZPCGZMbt2Jw7G/BONUS_1_ORTHOCASE-EN.png",
    description: "A rapid planning worksheet designed to take you from Case → Problems → Objectives → Priorities → Map in approximately 15 minutes. Use it when you want a faster way to organize your initial thinking.",
    items: [] as string[],
  },
  {
    number: 2,
    title: "The Complex Case Triage Sheet™",
    value: "$27",
    image: "https://cdn.magicpatterns.com/uploads/8y2aSdufmNEe1J3XaaF9bt/BONUS_2_ORTHOCASE-EN.png",
    description: "A visual triage tool designed to help you identify where the complexity of a case is coming from. Use it to organize:",
    items: ["Diagnostic complexity", "Multiple objectives", "Conflicting priorities", "Constraints", "Sequencing questions", "Areas requiring additional evaluation"],
  },
  {
    number: 3,
    title: "The Priority Matrix™",
    value: "$29",
    image: "https://cdn.magicpatterns.com/uploads/ovp4yrKQXLXVGQE7VqshRr/BONUS_3_ORTHOCASE-EN.png",
    description: "A dedicated visual matrix for organizing competing treatment considerations. Instead of keeping every consideration at the same level of importance, you'll have a structured place to compare and prioritize them.",
    items: [] as string[],
  },
  {
    number: 4,
    title: "30 Case Review Questions™",
    value: "$27",
    image: "https://cdn.magicpatterns.com/uploads/2XfSSnSerX2ZgAVg5W8SJD/BONUS_4_ORTHOCASE-EN.png",
    description: "Thirty structured questions designed to make you stop and review your thinking before moving forward. Use them to challenge:",
    items: ["Diagnosis", "Objectives", "Priorities", "Constraints", "Movement considerations", "Sequencing", "Reassessment", "Finishing"],
  },
  {
    number: 5,
    title: "The One-Page Case Brief™",
    value: "$27",
    image: "https://cdn.magicpatterns.com/uploads/3dDJARbvDs3iK74JRjc2qu/BONUS_5_ORTHOCASE-EN.png",
    description: "A professional one-page template for summarizing a case — perfect for reviewing your own cases or communicating the overall strategy with your team. Organize:",
    items: ["Case", "Problems", "Objectives", "Priorities", "Constraints", "Movement Considerations", "Sequence", "Review"],
  },
];
